// Default API root that will be used if no environment variable is provided
const DEFAULT_API_ROOT = 'https://api.infobate.com';

// Use environment variable if available, otherwise use default
let API_ROOT = process.env.REACT_APP_API_ROOT || DEFAULT_API_ROOT;

// Log the API root for debugging purposes
console.debug('API root is:', API_ROOT);

export default API_ROOT;